// extracted by mini-css-extract-plugin
export default {"article":"MealsSummary_article__g50Uq"};